import { addToGlobalThisRet } from "@plugins";

class ItcCustomSelect {
    constructor(target) {
        this.target = target;
        this.targetInput = this.target.querySelector(".js-input-select-target");
        this.trigger = this.target.querySelector(".js-input-select-trigger");
        this.dropdown = this.target.querySelector(".js-input-select-dropdown");

        this._init();
    }

    _init() {
        this.trigger.addEventListener("click", () => {
            this.trigger.classList.toggle("active");

            if (this.dropdown.classList.contains("active")) {
                this._closeDropdown();
            } else {
                this._openDropdown();
            }
        });
    }

    _openDropdown() {
        this.dropdown.classList.add("active");

        this._initOptionsListeners();
        this._initOutsideClickListener();
    }

    _closeDropdown() {
        this.dropdown.classList.remove("active");
        this.trigger.classList.remove("active");

        this._killOutsideClickListener();
    }

    _initOptionsListeners() {
        const options = this.dropdown.children;

        if (options && options.length) {
            Array.from(options).forEach((option) => {
                option.addEventListener("click", () => {
                    Array.from(options).forEach((option) => {
                        option.classList.remove("active");
                    });

                    option.classList.add("active");

                    this.targetInput.value = option.getAttribute("data-value");
                    this.trigger.textContent = option.textContent;
                    this.trigger.classList.add("chosen");

                    this._closeDropdown();

                    this.targetInput.dispatchEvent(
                        new Event("change", {
                            bubbles: true,
                        }),
                    );
                });
            });
        }
    }

    _outsideClickEvent(e) {
        if (!this.target.contains(e.target)) this._closeDropdown();
    }

    _initOutsideClickListener() {
        document.addEventListener("click", (e) => this._outsideClickEvent(e));
    }

    _killOutsideClickListener() {
        document.removeEventListener("click", (e) => this._outsideClickEvent(e));
    }
}

const selects = [...document.querySelectorAll(".js-input-select-init")];

if (selects && selects.length) initInputSelects(selects);

function initInputSelects(selects) {
    selects.forEach((select) => new ItcCustomSelect(select));
}

addToGlobalThisRet(initInputSelects, "initInputSelects");
